import RateComponent from './index.js'

if (!window.AliPlayerComponent) {
  window.AliPlayerComponent = {}
}
window.AliPlayerComponent.RateComponent = RateComponent



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/aliplayer/components/RateComponent/export.js